// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"954e553b","265":"f8194139","521":"85cf74bc","582":"013bc2fb","611":"de6f4eb4","722":"fb8065a3","870":"f8194139"}[chunkId] + ".chunk.css";
};